import {selectFeatureFlag as flopflipSelectFeatureFlag} from '@flopflip/react-redux';
import {FeatureToggleAdapter} from '@perion-undertone/ut-react-common';

const UT_ADAPTER_IDS =
    FeatureToggleAdapter.adapterIdentifiers || [FeatureToggleAdapter.id];

/**
 * Undertone wrapper: flopflip v15 selectFeatureFlag requires adapter id(s).
 * Calling selectFeatureFlag(name)(state) without binding them causes
 * "adapterIdentifiers is not iterable" inside @flopflip/react-redux.
 */
export function selectFeatureFlag(flagName) {
    return flopflipSelectFeatureFlag(flagName, UT_ADAPTER_IDS);
}
